"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var client_fetch_1 = require("@biw/client-fetch");
var types = tslib_1.__importStar(require("./action-types"));
function getProgramViews() {
    return client_fetch_1.clientFetch({
        url: '/contests',
        method: 'get',
        type: types.FETCHING_PROGRAM_VIEWS
    });
}
exports.getProgramViews = getProgramViews;
function getProgramView(programViewId) {
    return client_fetch_1.clientFetch({
        url: "/contests/" + programViewId,
        type: types.fetchingProgramView(programViewId)
    });
}
exports.getProgramView = getProgramView;
//# sourceMappingURL=api.js.map